<template>
  <el-dialog :visible.sync="formVisible" :close-on-click-modal="false" width="1000px" class="reject-dialog"
    @close="handleClose">
    <div slot="title" class="dialog-title">
      <img src="../../../assets/icon-reject.png" alt="reject" class="title-icon" />
      <div class="title-content">
        <div class="title-main">{{ (currentRow && currentRow.state === -1) ? '初审' : '终审' }}驳回申请</div>
        <div class="title-sub">{{ (currentRow && currentRow.state === -1) ? '初审驳回后申请无效' : '终审驳回到初审流程' }}</div>
      </div>
    </div>
    <div class="dialog-body" v-if="currentRow">
      <div class="detail-box">
        <div class="detail-item">
          <span class="label">用户信息：</span>
          <span class="value">{{ currentRow.customerName }} - {{ currentRow.currentLevelName }} - {{
            currentRow.customerPho }}</span>
        </div>
        <div class="detail-item">
          <span class="label">提交来源：</span>
          <span class="value">{{ getApplySource(currentRow) }}</span>
        </div>
        <div class="detail-item">
          <span class="label">申请类型：</span>
          <span class="value">{{ getApplyType(currentRow) }}</span>
        </div>
        <div class="detail-item" v-if="currentRow.registrationType<10">
          <span class="label">报名费用：</span>
          <span class="value">{{ currentRow.fee }}</span>
        </div>
      </div>
      <div class="gift-box" v-if="currentRow.giftCombineName">
        <div class="detail-item">
          <span class="label">赠送礼包：</span>
          <span class="value">{{ currentRow.giftCombineName }}</span>
        </div>
      </div>
      <!-- 付款凭证信息 -->
      <template v-if="currentRow.payPOList && currentRow.payPOList.length > 0">
        <div class="voucher-box">
          <div class="detail-item">
            <span class="label">付款凭证：</span>
            <span class="value">报名金额{{ currentRow.fee }}元</span>
          </div>
          <div class="voucher-item" v-for="(item, index) in currentRow.payPOList" :key="index">
            <div class="pay-img">
              <el-image :src="item.payImg" style="width: 100px; height: 100px;"
                :preview-src-list="currentRow.payPOList.map(p => p.payImg)" />
            </div>
            <div class="pay-info">
              <div class="pay-grid">
                <div class="pay-field-view">
                  <span class="field-label">收款银行：</span>
                  <span class="field-value">{{ item.payBank || '-' }}</span>
                </div>
                <div class="pay-field-view">
                  <span class="field-label">付款方式：</span>
                  <span class="field-value">{{ item.payMethod === 1 ? '扫码支付' : item.payMethod === 2 ? '银行转账' : '-' }}</span>
                </div>
                <div class="pay-field-view">
                  <span class="field-label">支付单号：</span>
                  <span class="field-value">{{ item.payNum || '-' }}</span>
                </div>
                <div class="pay-field-view">
                  <span class="field-label">付款金额：</span>
                  <span class="field-value">{{ item.payMoney || '-' }}</span>
                </div>
                <div class="pay-field-view">
                  <span class="field-label">付款日期：</span>
                  <span class="field-value">{{ item.payTime || '-' }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="detail-item" style="margin-top: 10px;">
            <span class="label">赠送金额：</span>
            <span class="value">{{ currentRow.upgradeGiftAmount || '-' }}</span>
          </div>
        </div>
      </template>
      <!-- 附件信息 -->
      <div class="voucher-box" v-if="currentRow.applyVoucher">
        <div class="detail-item">
          <span class="label">附件：</span>
          <div class="voucher-imgs">
            <el-image v-for="(img, idx) in currentRow.applyVoucher.split(',')" :key="idx"
              style="width: 60px; height: 60px; margin-right: 8px;" :src="img"
              :preview-src-list="currentRow.applyVoucher.split(',')" />
          </div>
        </div>
      </div>
      <div class="voucher-box" v-if="currentRow.content">
        <div class="detail-item">
          <span class="label">申请原因：</span>
          <span class="value">{{ currentRow.content }}</span>
        </div>
      </div>
      <el-form v-if="currentRow" ref="rejectForm" :model="form" :rules="formRules" label-width="110px"
        class="reject-form">
        <el-form-item label="申请人：">
          <div>{{ currentRow.realName }}-{{ currentRow.userPho }}</div>
        </el-form-item>
        <el-form-item label="提交时间：">
          <div>{{ currentRow.createdTime }}</div>
        </el-form-item>
        <el-form-item label="驳回原因：" prop="reason" class="reason-input">
          <el-input v-model="form.reason" type="text" placeholder="请输入驳回原因" />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doReject" :loading="isLoading">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import customerRegistrationApi from '@/api/cust/customerRegistration'
export default {
  data() {
    return {
      formVisible: false,
      isLoading: false,
      currentRow: null,
      form: {
        reason: ''
      },
      formRules: {
        reason: [{ required: true, message: '请输入驳回原因', trigger: 'blur' }]
      }
    }
  },
  methods: {
    handleCreate(row) {
      this.currentRow = row
      this.form.reason = ''
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs.rejectForm && this.$refs.rejectForm.clearValidate()
      })
    },
    handleClose() {
      this.currentRow = null
      this.form.reason = ''
    },
    formatUserInfo(row) {
      if (row.targetUserName && row.targetUserLevelName && row.targetUserMobile) {
        return `${row.targetUserName}-${row.targetUserLevelName}-${row.targetUserMobile}`
      }
      return row.userInfo || '-'
    },
    getApplySource(row) {
      if (!row) return '-'
      if (row.dataSource === 1) return 'app业务员提交'
      if (row.dataSource === 2) return '管理后台提交'
      if (row.dataSource === 3) return 'app客户申请'
      if (row.dataSource === 4) return '管理后台导入'
      return '-'
    },
    getApplyType(row) {
      if (!row) return '-'
      if (row.registrationType === 1) return '普通人员升级研修班'
      if (row.registrationType === 2) return '普通人员升级体验班'
      if (row.registrationType === 3) return '体验班升级研修班'
      //10|体降普，20|研降普
      if (row.registrationType === 10) return '体验班降级为普通人员'
      if (row.registrationType === 20) return '研修班降级为普通人员'
      if (row.registrationType === 30) return '研修班降级为体验班'
      return '-'
    },
    formatApplicantInfo(row) {
      if (row.applicantName && row.applicantLevelName && row.applicantMobile) {
        return `${row.applicantName}-${row.applicantLevelName}-${row.applicantMobile}`
      }
      return row.applicantInfo || '-'
    },
    getVoucherImages(row) {
      if (!row) return []
      if (row.imgUrl) {
        return row.imgUrl.split(',').filter(Boolean)
      }
      return []
    },
    doReject() {
      this.$refs.rejectForm.validate(valid => {
        if (valid && this.currentRow && this.currentRow.id) {
          this.$confirm('是否确认驳回申请', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(() => {
            this.isLoading = true
            if (this.currentRow.state === -1) {
            this.$emit('reject', {
              id: this.currentRow.id,
              state: 2,
              reasonForRejection: this.form.reason
            }, () => {
              this.isLoading = false
              this.formVisible = false
            }).catch(() => {
              this.isLoading = false
            })
          }else{
            // 终审：直接调用 agreeOrReject 接口
            this.isLoading = true
            customerRegistrationApi.agreeOrReject({
              id: this.currentRow.id,
              version:2,
              state: -1
            }).then(res => {
              if (res.code === '0') {
                this.$message.success('终审驳回成功')
                this.$emit('refresh')
                this.formVisible = false
              } else {
                this.$message.error(res.msg || '操作失败')
              }
              this.isLoading = false
            }).catch(err => {
              this.$message.error('操作失败: ' + (err.message || ''))
              this.isLoading = false
            }).finally(() => {
              this.isLoading = false
            })

          }
          }).catch(() => { })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.reject-dialog ::v-deep .el-dialog__header {
  padding: 20px 20px 10px;
}

.reject-dialog ::v-deep .el-dialog__body {
  padding: 10px 20px 20px;
}

.dialog-title {
  display: flex;
  gap: 20px;

  .title-icon {
    width: 60px;
  }

  .title-content {
    .title-main {
      font-size: 18px;
      color: #000000;
    }

    .title-sub {
      font-size: 14px;
      color: #8F8E8E;
      padding-top: 10px;
    }
  }
}

.detail-box {
  background: #f5f7fa;
  border-radius: 4px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .detail-item {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    font-size: 16px;
    line-height: 14px;

    &:last-child {
      margin-bottom: 0;
    }

    .label {
      color: #666666;
      display: inline-block;
    }

    .value {
      color: #6C6C6C;
    }

    .voucher-imgs {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
    }
  }
}

.gift-box {
  margin-top: 10px;
  padding: 20px 8px;
  border-radius: 4px;
  background-color: #F8F8F8;

  .detail-item {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    color: #666666;
  }
}

.voucher-box {
  margin-top: 10px;
  padding: 20px 8px;
  border-radius: 4px;
  background-color: #F8F8F8;

  .detail-item {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    color: #666666;

    .label {
      flex-shrink: 0;
    }
  }

  .pay-form {
    padding-top: 20px;
  }

  .voucher-imgs {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .voucher-item {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 10px 0;

    .pay-img {
      position: relative;

      .pay-img-actions {
        position: absolute;
        right: 0;
        left: 0;
        bottom: 0;
        height: 26px;
        background-color: #C5C5C5;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0 4px 0 4px;

        .el-icon-delete {
          color: #E73F3F;
          cursor: pointer;
          font-size: 16px;
        }
      }
    }

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
  }

  .pay-actions {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .pay-action-btn {
    width: 120px;
  }

  .pay-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 12px;
    row-gap: 10px;

    ::v-deep .el-form-item {
      margin-bottom: 0;
    }

    ::v-deep .el-form-item__error {
      position: static;
      padding-top: 2px;
      line-height: 1.2;
    }

    ::v-deep .el-form-item__content,
    ::v-deep .el-select,
    ::v-deep .el-input,
    ::v-deep .el-date-editor {
      width: 100%;
    }

    .pay-field-view {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 14px;
      color: #666666;

      .field-label {
        flex-shrink: 0;
        color: #999999;
      }

      .field-value {
        color: #333333;
        word-break: break-all;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .pay-grid {
      grid-template-columns: 1fr;
    }

    .pay-action-btn {
      width: 100%;
    }
  }
}

.reject-form {
  margin-top: 20px;

  .el-form-item {
    margin-bottom: 16px;

    ::v-deep .el-form-item__label {
      line-height: 14px;
      font-size: 16px;
      text-align: right;
      color: #666666;
    }

    ::v-deep .el-form-item__content {
      line-height: 14px;
      font-size: 16px;
      color: #666666;
    }

    &.reason-input {
      ::v-deep .el-form-item__label {
        line-height: 40px;
      }
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
